import {NgModule} from '@angular/core';
import {Router, RouterModule, Routes} from '@angular/router';
import {ConfigService} from "./@core/config/services/config.service";

const routesWithoutJwt: Routes = [
  {
    path: 'information',
    loadChildren: () =>
      import('./information/information.module').then((m) => m.InformationModule)
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: '**',
    redirectTo: 'pages'
  },
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full'
  }
];

const routesWithJwt: Routes = [
  {
    path: 'authentication',
    loadChildren: () =>
      import('./@core/authentication/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'information',
    loadChildren: () =>
      import('./information/information.module').then((m) => m.InformationModule)
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: '**',
    redirectTo: 'pages'
  },
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routesWithJwt, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(
    private readonly configService: ConfigService,
    private readonly router: Router,
  ) {
    // We need to do this call here because APP_INITIALIZER is not yet initialized
    this.configService.getFeatureConfig().subscribe({
      next: (featureConfig) => {
              if (this.configService?.featureConfig?.kommunalportalAuth) {
                this.router.resetConfig(routesWithoutJwt);
              } else if (this.configService?.featureConfig?.jwtAuth) {
                this.router.resetConfig(routesWithJwt);
              } else {
                console.error('Unable to load featureConfig. Using default (jwt).');
                this.router.resetConfig(routesWithJwt);
              }
            },
      error: (err) => { console.log(err); }
    });
  }
}
